module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-painless-time-tracking@2x-ce7d26d437cfbfedb5c2ae4fae485bc1.png";